<template>
	<div style="margin: 10px;">
		<el-card class="box-card">
			<el-row>
				<el-col :span="24">
					<h4 class="title">基本设置</h4>
					<el-form ref="form" :model="form" label-width="160px" :rules="rules">
						<el-form-item label="网站名称" prop="name">
							<el-input v-model="form.name" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="网站LOGO" prop="pic">
						
							
							<el-upload  drag  list-type="picture-card"  action="" multiple :limit="1"
							 :on-success="getLogo" :file-list="logoList" :on-remove="RemoveLogo" :on-exceed="handleLogo" :before-upload="beforePic" >
								<i class="el-icon-picture-outline"></i>
								<br />
								<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<!-- <img :src="settings.apiBaseImg+form.pic" alt="" v-if="form.pic" style="width: 200px;height: 200px;"> -->
						</el-form-item>
						<el-form-item label="底部LOGO" prop="pics">
						
							
							<el-upload  drag  list-type="picture-card"  action="" multiple :limit="1"
							 :on-success="getLogos" :file-list="logoLists" :on-remove="RemoveLogos" :on-exceed="handleLogos" :before-upload="beforePics" >
							<i class="el-icon-picture-outline"></i>
							<br />
							<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<!-- <img :src="settings.apiBaseImg+form.pic" alt="" v-if="form.pic" style="width: 200px;height: 200px;"> -->
						</el-form-item>
						<el-form-item label="网站网址" prop="link">
							<el-input v-model="form.link" style="width:30%"></el-input><span class="picTip">如：http://website.renhegroup.net</span>
						</el-form-item>
						<el-form-item label="网站关键词" prop="keyWord">
							<el-input v-model="form.keyWord" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="关键词描述" prop="desc">
							<el-input v-model="form.desc" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="form.email" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="传真" prop="fax">
							<el-input v-model="form.fax" style="width: 30%;"></el-input>
						</el-form-item>
						<div class="line"></div>
						<h4 class="title">底部信息设置</h4><span class="titleTip">（显示在网站前台底部）</span>
						<el-form-item label="版权信息" prop="copyright">
							<el-input v-model="form.copyright" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="地址" prop="address">
							<el-input v-model="form.address" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="联系方式" prop="contact">
							<el-input v-model="form.contact" style="width: 30%;"></el-input>
						</el-form-item>
						<div class="line"></div>
						<h4 class="title"></h4>
						<el-form-item label="二维码" prop="ewm">
							<!-- <el-input v-model="form.ewm" style="width:30%;float: left;" readonly></el-input> -->
							<el-upload drag  list-type="picture-card" action="" multiple :limit="1" :before-upload="beforePic1"
							 :on-success="getEwm" :file-list="ewmList" :on-remove="RemoveEwm" :on-exceed="handleLogo">
									<i class="el-icon-picture-outline"></i>	
									<br />
									<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="QQ" prop="qq">
							<el-input v-model="form.qq" style="width: 30%;"></el-input>
						</el-form-item>
						<div class="line"></div>
						<h4 class="title"></h4>
						<el-form-item label="视频" prop="video">
							<!-- <el-input v-model="form.video" style="width:30%;float: left;"readonly></el-input> -->
							<el-upload drag  list-type="picture-card" class="upload-demo" action="" multiple :limit="1" :before-upload="beforePic2"
							 :on-success="getVideo" :file-list="videoList" :on-remove="RemoveVideo" :on-exceed="handleLogo">
								<i class="el-icon-video-camera"></i>
								<br />
								<span class="uploadTip">将视频拖到此处，或点击上传</span>
							</el-upload>
							<!-- <video :src="settings.apiBaseImg+form.video" v-if="form.video" style="width: 200px;height: 200px;" autoplay="autoplay"></video> -->
						</el-form-item>
						<div class="line"></div>
						<h4 class="title"></h4>
						<el-form-item label="其他">
							  <!-- <editor id="editor_id" height="500px"  :content.sync="editorText"></editor> -->
							<editor v-model="editorText" :isClear="isClear" @change="change"></editor>
						</el-form-item>

						<el-form-item>
							<input type="button" class="submit" @click="onSubmit('form')" value="提交">
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
import E from "wangeditor";
	import Editor from '../../../components/tinymce.vue'
	

	export default {
		components: {
			Editor,
			
		},
		data() {
			return {
				form: {
					//网站名称
					name: '',
					//网站logo
					pic: '',
					pics: '',
					//网站网址
					link: '',
					//网站关键词
					keyWord: '',
					//关键词描述
					desc: '',
					//邮箱
					email: '',
					//传真
					fax: '',
					//版权信息
					copyright: '',
					//地址
					address: '',
					//联系方式
					contact: '',
					//其他
					detail: '',
					//二维码
					ewm: '',
					//qq
					qq: '',
					//视频
					video: '',
				},
				editorText:'',
				isClear: false,
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					link: [{
						required: true,
						message: '请输入网站网址',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请输入网站关键词',
						trigger: 'blur'
					}],
					keyWord: [{
						required: true,
						message: '请输入关键词描述',
						trigger: 'blur'
					}],
					email: [{
						required: true,
						message: '请输入邮箱',
						trigger: 'blur'
					}],
					fax: [{
						required: true,
						message: '请输入传真',
						trigger: 'blur'
					}],
					copyright: [{
						required: true,
						message: '请输入版权信息',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}],
					qq: [{
						required: true,
						message: '请输入QQ',
						trigger: 'blur'
					}],
					ewm: [{
						required: true,
						message: '请输入二维码',
						trigger: 'blur'
					}],
					video: [{
						required: true,
						message: '请输入视频',
						trigger: 'blur'
					}],

				},
				ewmList: [],
				videoList: [],
				logoList: [],
				logoLists: [],
				id: ''
			}
		},
		mounted() {},
		created() {
			this.getData()
		},
		methods: {
			change(val) {
				console.log(val)
			},
			getData() {
				// })
				var obj = this;
				obj.$http({
					method: 'get',
					url: '/api/v1/info/get',
					params: {
						uid: localStorage.getItem('uid')
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.form.name = res.data.data.title
						this.form.pic = res.data.data.logo
						this.form.pics = res.data.data.logoFooter
						this.form.link = res.data.data.website
						this.form.keyWord = res.data.data.keyword
						this.form.desc = res.data.data.keywordInfo
						this.form.email = res.data.data.email
						this.form.fax = res.data.data.fax
						this.form.copyright = res.data.data.copyright
						this.form.address = res.data.data.address
						this.form.contact = res.data.data.mobile
						this.editorText = res.data.data.content
						this.form.ewm = res.data.data.qrcode
						this.form.qq = res.data.data.qq
						this.form.video = res.data.data.video
						if(res.data.data.video != null){
							this.videoList.push({url:this.settings.apiBaseImg +  res.data.data.video})	
						}
						this.id = res.data.data.id
						this.logoList.push({url:this.settings.apiBaseImg +res.data.data.logo})
						this.ewmList.push({url:this.settings.apiBaseImg +res.data.data.qrcode})
						if(res.data.data.logoFooter != null){
							this.logoLists.push({url:this.settings.apiBaseImg +res.data.data.logoFooter})
						}
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			onSubmit(formName) {
				this.logoList=[]
				this.ewmList=[]
				this.logoLists=[]
				this.videoList=[]
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this;
						obj.$http({
							method: 'post',
							url: 'api/v1/info/update',
							data:{
								id: this.id,
								 
								title: this.form.name,
								logo: this.form.pic,
								website: this.form.link,
								keyword: this.form.keyWord,
								keywordInfo: this.form.desc,
								email: this.form.email,
								fax: this.form.fax,
								copyright: this.form.copyright,
								address: this.form.address,
								mobile: this.form.contact,
								content: this.editorText,
								qrcode: this.form.ewm,
								qq: this.form.qq,
								video: this.form.video,
								logoFooter:this.form.pics
							},
						}).then((res) => {
							if (res.data.status == 200) {
								obj.$message.success('修改成功')
								this.getData()
							} else {
								obj.$message.error(res.data.message)
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			//网站logostart
			getLogo(file, fileList) {
				this.form.pic = file.data.fileName
			},
			RemoveLogo() {
				this.form.pic = ''
				this.form.logoList=[]
			},
			getLogos(file, fileList) {
				this.form.pics = file.data.fileName
			},
			RemoveLogos() {
				this.form.pics = ''
				this.form.logoLists=[]
			},
			//网站logoENd
			//二维码START
			getEwm(file, fileList) {
				this.form.ewm = file.data.fileName
			},
			RemoveEwm() {
				this.form.ewm = ''
			},
			//二维码end
			//视频START
			getVideo(file, fileList) {
				this.videoList=[]
				this.form.video = file.data.fileName
				// this.videoList.push({url:this.settings.apiBaseImg + file.data.fileName})
			},
			RemoveVideo() {
				this.form.video = ''
			},
			handleLogo(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleLogos(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			//视频end
			beforePic(file, fileList) {
				this.loading = true
				this.logoList=[]
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/adver/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
						obj.$message.success(res.data.message)
						
						this.logoList.push({url:this.settings.apiBaseImg +res.data.data.url})
						this.form.pic = res.data.data.url
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			beforePics(file, fileList) {
				this.loading = true
				this.logoLists=[]
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/info/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
						obj.$message.success(res.data.message)
						
						this.logoLists.push({url:this.settings.apiBaseImg +res.data.data.path})
						this.form.pics = res.data.data.path
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
            //上傳二維碼
			beforePic1(file, fileList) {
				this.loading = true
				this.ewmList=[]
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/common/upload',
					data: formData,
					
				}).then((res) => {
					console.log(res)
					if (res.status == 200) {
						this.loading = false
						obj.$message.success(res.data.message)
						
						this.ewmList.push({url:res.data.data.url})
						this.form.ewm = res.data.data.url
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},

			beforePic2(file, fileList) {
				this.loading = true
				this.videoList=[]
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/common/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
						obj.$message.success(res.data.message)
						
						this.videoList.push({url:res.data.data.url})
						this.form.video = res.data.data.url
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-input__inner {
		height: 30px !important;
		line-height: 30px;
	}

	/deep/ .el-form-item__label {
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 40px;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #ccc;
		opacity: 0.3;
	}

	.title {
		display: inline-block;
		padding: 10px;
	}

	.titleTip {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}
	  .avatar {
	    width: 140px;
	    height: 140px;
	    display: block;
	  }
</style>



// WEBPACK FOOTER //
// src/views/system/system/basicSystem.vue